export class Protocol {
  constructor(private readonly number: string) {}

  getNumber(): string {
    return this.number;
  }
}
